// Country Code to Country Name Mapping
// Maps ISO country codes and SVG IDs to full country names

export const countryCodeToName = {
  // ISO 2-letter codes
  'AF': 'Afghanistan',
  'AL': 'Albania',
  'DZ': 'Algeria',
  'AO': 'Angola',
  'AR': 'Argentina',
  'AM': 'Armenia',
  'AU': 'Australia',
  'AT': 'Austria',
  'AZ': 'Azerbaijan',
  'BH': 'Bahrain',
  'BD': 'Bangladesh',
  'BY': 'Belarus',
  'BE': 'Belgium',
  'BZ': 'Belize',
  'BJ': 'Benin',
  'BT': 'Bhutan',
  'BO': 'Bolivia',
  'BA': 'Bosnia and Herzegovina',
  'BW': 'Botswana',
  'BR': 'Brazil',
  'BN': 'Brunei',
  'BG': 'Bulgaria',
  'BF': 'Burkina Faso',
  'BI': 'Burundi',
  'KH': 'Cambodia',
  'CM': 'Cameroon',
  'CA': 'Canada',
  'CV': 'Cape Verde',
  'CF': 'Central African Republic',
  'TD': 'Chad',
  'CL': 'Chile',
  'CN': 'China',
  'CO': 'Colombia',
  'KM': 'Comoros',
  'CG': 'Congo',
  'CR': 'Costa Rica',
  'CI': 'Ivory Coast',
  'HR': 'Croatia',
  'CU': 'Cuba',
  'CY': 'Cyprus',
  'CZ': 'Czech Republic',
  'CD': 'Democratic Republic of the Congo',
  'DK': 'Denmark',
  'DJ': 'Djibouti',
  'DO': 'Dominican Republic',
  'EC': 'Ecuador',
  'EG': 'Egypt',
  'SV': 'El Salvador',
  'GQ': 'Equatorial Guinea',
  'ER': 'Eritrea',
  'EE': 'Estonia',
  'ET': 'Ethiopia',
  'FJ': 'Fiji',
  'FI': 'Finland',
  'FR': 'France',
  'GA': 'Gabon',
  'GM': 'Gambia',
  'GE': 'Georgia',
  'DE': 'Germany',
  'GH': 'Ghana',
  'GR': 'Greece',
  'GT': 'Guatemala',
  'GN': 'Guinea',
  'GW': 'Guinea-Bissau',
  'GY': 'Guyana',
  'HT': 'Haiti',
  'HN': 'Honduras',
  'HU': 'Hungary',
  'IS': 'Iceland',
  'IN': 'India',
  'ID': 'Indonesia',
  'IR': 'Iran',
  'IQ': 'Iraq',
  'IE': 'Ireland',
  'IL': 'Israel',
  'IT': 'Italy',
  'JM': 'Jamaica',
  'JP': 'Japan',
  'JO': 'Jordan',
  'KZ': 'Kazakhstan',
  'KE': 'Kenya',
  'KI': 'Kiribati',
  'KP': 'North Korea',
  'KR': 'South Korea',
  'KW': 'Kuwait',
  'KG': 'Kyrgyzstan',
  'LA': 'Laos',
  'LV': 'Latvia',
  'LB': 'Lebanon',
  'LS': 'Lesotho',
  'LR': 'Liberia',
  'LY': 'Libya',
  'LI': 'Liechtenstein',
  'LT': 'Lithuania',
  'LU': 'Luxembourg',
  'MK': 'Macedonia',
  'MG': 'Madagascar',
  'MW': 'Malawi',
  'MY': 'Malaysia',
  'MV': 'Maldives',
  'ML': 'Mali',
  'MT': 'Malta',
  'MH': 'Marshall Islands',
  'MR': 'Mauritania',
  'MU': 'Mauritius',
  'MX': 'Mexico',
  'FM': 'Micronesia',
  'MD': 'Moldova',
  'MC': 'Monaco',
  'MN': 'Mongolia',
  'ME': 'Montenegro',
  'MA': 'Morocco',
  'MZ': 'Mozambique',
  'MM': 'Myanmar',
  'NA': 'Namibia',
  'NR': 'Nauru',
  'NP': 'Nepal',
  'NL': 'Netherlands',
  'NZ': 'New Zealand',
  'NI': 'Nicaragua',
  'NE': 'Niger',
  'NG': 'Nigeria',
  'NO': 'Norway',
  'OM': 'Oman',
  'PK': 'Pakistan',
  'PW': 'Palau',
  'PS': 'Palestine',
  'PA': 'Panama',
  'PG': 'Papua New Guinea',
  'PY': 'Paraguay',
  'PE': 'Peru',
  'PH': 'Philippines',
  'PL': 'Poland',
  'PT': 'Portugal',
  'QA': 'Qatar',
  'RO': 'Romania',
  'RU': 'Russia',
  'RW': 'Rwanda',
  'KN': 'Saint Kitts and Nevis',
  'LC': 'Saint Lucia',
  'VC': 'Saint Vincent and the Grenadines',
  'WS': 'Samoa',
  'SM': 'San Marino',
  'ST': 'Sao Tome and Principe',
  'SA': 'Saudi Arabia',
  'SN': 'Senegal',
  'RS': 'Serbia',
  'SC': 'Seychelles',
  'SL': 'Sierra Leone',
  'SG': 'Singapore',
  'SK': 'Slovakia',
  'SI': 'Slovenia',
  'SB': 'Solomon Islands',
  'SO': 'Somalia',
  'ZA': 'South Africa',
  'ES': 'Spain',
  'LK': 'Sri Lanka',
  'SD': 'Sudan',
  'SR': 'Suriname',
  'SZ': 'Swaziland',
  'SE': 'Sweden',
  'CH': 'Switzerland',
  'SY': 'Syria',
  'TW': 'Taiwan',
  'TJ': 'Tajikistan',
  'TZ': 'Tanzania',
  'TH': 'Thailand',
  'TL': 'Timor-Leste',
  'TG': 'Togo',
  'TO': 'Tonga',
  'TT': 'Trinidad and Tobago',
  'TN': 'Tunisia',
  'TR': 'Turkey',
  'TM': 'Turkmenistan',
  'TV': 'Tuvalu',
  'UG': 'Uganda',
  'UA': 'Ukraine',
  'AE': 'United Arab Emirates',
  'GB': 'United Kingdom',
  'US': 'United States',
  'UY': 'Uruguay',
  'UZ': 'Uzbekistan',
  'VU': 'Vanuatu',
  'VA': 'Vatican City',
  'VE': 'Venezuela',
  'VN': 'Vietnam',
  'YE': 'Yemen',
  'ZM': 'Zambia',
  'ZW': 'Zimbabwe'
};

// Also map common class names and variations
export const classNameToName = {
  'Angola': 'Angola',
  'Argentina': 'Argentina',
  'Australia': 'Australia',
  // Add more as needed
};

// Alternative country names mapping (common variations in SVG files)
export const alternativeCountryNames = {
  // Russia variations
  'Russian Federation': 'Russia',
  'Russian': 'Russia',
  'RU': 'Russia',
  
  // United States variations
  'United States of America': 'United States',
  'USA': 'United States',
  'US': 'United States',
  
  // United Kingdom variations
  'Great Britain': 'United Kingdom',
  'Britain': 'United Kingdom',
  'UK': 'United Kingdom',
  'GB': 'United Kingdom',
  
  // Europe variations
  'Czechia': 'Czech Republic',
  'Czech': 'Czech Republic',
  'The Netherlands': 'Netherlands',
  'Holland': 'Netherlands',
  'NL': 'Netherlands',
  'Bosnia': 'Bosnia and Herzegovina',
  'Bosnia and Herzegovina': 'Bosnia and Herzegovina',
  'Macedonia': 'North Macedonia',
  'FYROM': 'North Macedonia',
  
  // Asia variations
  'Myanmar (Burma)': 'Myanmar',
  'Burma': 'Myanmar',
  'Korea, South': 'South Korea',
  'Korea, Republic of': 'South Korea',
  'South Korea': 'South Korea',
  'Korea, North': 'North Korea',
  'DPRK': 'North Korea',
  'North Korea': 'North Korea',
  'The Philippines': 'Philippines',
  'Philippines': 'Philippines',
  'UAE': 'United Arab Emirates',
  'United Arab Emirates': 'United Arab Emirates',
  'East Timor': 'Timor-Leste',
  'Timor-Leste': 'Timor-Leste',
  
  // Africa variations
  "Côte d'Ivoire": 'Ivory Coast',
  'Cote d\'Ivoire': 'Ivory Coast',
  'Côte d\'Ivoire': 'Ivory Coast',
  'Ivory Coast': 'Ivory Coast',
  'CI': 'Ivory Coast',
  'Democratic Republic of Congo': 'Democratic Republic of the Congo',
  'DRC': 'Democratic Republic of the Congo',
  'Democratic Republic of the Congo': 'Democratic Republic of the Congo',
  'Dem. Rep. Congo': 'Democratic Republic of the Congo',
  'Republic of Congo': 'Congo',
  'Republic of the Congo': 'Congo',
  'Swaziland': 'Eswatini',
  'Eswatini': 'Eswatini',
  'Cabo Verde': 'Cape Verde',
  'Cape Verde': 'Cape Verde',
  'The Gambia': 'Gambia',
  'Gambia': 'Gambia',
  
  // Other variations
  'The Bahamas': 'Bahamas',
  'Bahamas': 'Bahamas',
  'Trinidad & Tobago': 'Trinidad and Tobago',
  'Trinidad and Tobago': 'Trinidad and Tobago',
  'Antigua & Barbuda': 'Antigua and Barbuda',
  'Antigua and Barbuda': 'Antigua and Barbuda',
  'St. Kitts and Nevis': 'Saint Kitts and Nevis',
  'Saint Kitts and Nevis': 'Saint Kitts and Nevis',
  'St. Vincent and the Grenadines': 'Saint Vincent and the Grenadines',
  'Saint Vincent and the Grenadines': 'Saint Vincent and the Grenadines',
  'São Tomé and Príncipe': 'Sao Tome and Principe',
  'São Tomé & Príncipe': 'Sao Tome and Principe',
  'Sao Tome and Principe': 'Sao Tome and Principe',
  
  // Additional common variations
  'People\'s Republic of China': 'China',
  'PRC': 'China',
  'Kingdom of Saudi Arabia': 'Saudi Arabia',
  'Saudi Arabia': 'Saudi Arabia',
  'Islamic Republic of Iran': 'Iran',
  'Iran': 'Iran',
  'Republic of Iraq': 'Iraq',
  'Iraq': 'Iraq',
  'State of Israel': 'Israel',
  'Israel': 'Israel',
  'Hashemite Kingdom of Jordan': 'Jordan',
  'Jordan': 'Jordan',
  'Lebanese Republic': 'Lebanon',
  'Lebanon': 'Lebanon',
  'Syrian Arab Republic': 'Syria',
  'Syria': 'Syria',
  'Republic of Kazakhstan': 'Kazakhstan',
  'Kazakhstan': 'Kazakhstan',
  'Republic of Uzbekistan': 'Uzbekistan',
  'Uzbekistan': 'Uzbekistan',
  'Mongolia': 'Mongolia',
  'Federal Democratic Republic of Nepal': 'Nepal',
  'Nepal': 'Nepal',
  'Democratic Socialist Republic of Sri Lanka': 'Sri Lanka',
  'Sri Lanka': 'Sri Lanka',
  'Republic of Yemen': 'Yemen',
  'Yemen': 'Yemen',
  'Sultanate of Oman': 'Oman',
  'Oman': 'Oman',
  'State of Qatar': 'Qatar',
  'Qatar': 'Qatar',
  'State of Kuwait': 'Kuwait',
  'Kuwait': 'Kuwait',
  'Kingdom of Bahrain': 'Bahrain',
  'Bahrain': 'Bahrain',
  
  // From unmapped list - alternative names for existing countries
  'Republic of Korea': 'South Korea',
  'Lao PDR': 'Laos',
  'Dem. Rep. Korea': 'North Korea',
  'Brunei Darussalam': 'Brunei',
  'São Tomé and Principe': 'Sao Tome and Principe',
  'São Tomé & Principe': 'Sao Tome and Principe',
};

// Strip common prefixes and suffixes from country names
const stripCountryPrefixes = (name) => {
  const prefixes = [
    'Republic of ',
    'Kingdom of ',
    'State of ',
    'United ',
    'Federation of ',
    'Democratic ',
    'People\'s Republic of ',
    'Islamic Republic of ',
    'Hashemite Kingdom of ',
    'Sultanate of ',
    'Principality of ',
    'Grand Duchy of ',
    'Commonwealth of ',
    'The ',
  ];
  
  let cleaned = name;
  for (const prefix of prefixes) {
    if (cleaned.startsWith(prefix)) {
      cleaned = cleaned.substring(prefix.length);
      break;
    }
  }
  
  // Also remove common suffixes
  const suffixes = [
    ' (Burma)',
    ' (Republic)',
    ' (Democratic Republic)',
  ];
  
  for (const suffix of suffixes) {
    if (cleaned.endsWith(suffix)) {
      cleaned = cleaned.substring(0, cleaned.length - suffix.length);
    }
  }
  
  return cleaned.trim();
};

// Get country name from code, class, or name
export const normalizeCountryName = (identifier) => {
  if (!identifier) return null;
  
  const normalized = identifier.trim();
  
  // First check alternative names (common variations) - case sensitive
  if (alternativeCountryNames[normalized]) {
    return alternativeCountryNames[normalized];
  }
  
  // Check case-insensitive alternative names
  const normalizedLower = normalized.toLowerCase();
  for (const [alt, standard] of Object.entries(alternativeCountryNames)) {
    if (alt.toLowerCase() === normalizedLower) {
      return standard;
    }
  }
  
  // Try stripping common prefixes and check again
  const stripped = stripCountryPrefixes(normalized);
  if (stripped !== normalized) {
    // Check if stripped version matches alternative names
    if (alternativeCountryNames[stripped]) {
      return alternativeCountryNames[stripped];
    }
    // Check case-insensitive
    const strippedLower = stripped.toLowerCase();
    for (const [alt, standard] of Object.entries(alternativeCountryNames)) {
      if (alt.toLowerCase() === strippedLower) {
        return standard;
      }
    }
  }
  
  // If it's already a full country name, return it
  if (countryCodeToName[identifier] || classNameToName[identifier]) {
    return countryCodeToName[identifier] || classNameToName[identifier];
  }
  
  // Check if it's a country code
  if (countryCodeToName[identifier.toUpperCase()]) {
    return countryCodeToName[identifier.toUpperCase()];
  }
  
  // Check if it's a class name
  if (classNameToName[identifier]) {
    return classNameToName[identifier];
  }
  
  // Try stripped version in countryCodeToName
  if (stripped !== normalized) {
    if (countryCodeToName[stripped]) {
      return countryCodeToName[stripped];
    }
  }
  
  // Return as-is (might be a full name already)
  return identifier;
};

